// The five Lead Categories in the order people read them (matches src/warningDashboard/leadCategory.js on the server).
// Used to order the category filter on the results pages; the server stays the source of truth for which category a lead is in.
export const LEAD_CATEGORY_ORDER = [
  'FB leads - Kerala',
  'FB leads - GCC',
  'Social media - Kerala',
  'Social media - GCC',
  'Uncategorized',
];
